export const clearHtmlTagsAndSymbols = (sentence) => {
  // better to use DOMPurify instead of DOMParser to avoid XSS attacks
  const doc = new DOMParser().parseFromString(sentence, 'text/html')
  return (doc.body.textContent || '')
    .replace(/(<([^>]+)>)/gi, '')
    .replace(/&[^;]+;/g, '')
}
